import React, { useCallback, useEffect, useMemo, useRef, useState } from "react";
import ScrollView from "@/baseComponents/ScrollView";
import "./index.less";
import { TimeLableComponent, TimeLineComponent } from "../TimeLableAndLine";
import dayjs, { Dayjs } from "dayjs";
import { CurrentLine } from "../../View/DayView";
import {
  ScheduleByDateAndUsersProps,
  ScheduleByUser,
  UserScheduleViewHeader
} from "../BusyIdleHeader";
import ViewScheduleByUserItem from "../ScheduleByUserItem";
import { getScheduleByUserElements } from "../../utils/ComputedElement";
import {
  handleBusyIdleMouseUpFun,
  handleMouseDownFun,
  handleMouseMoveFun,
  handleScrollFrameFun,
  pauseEvent
} from "../../View/dragMouse/mouseEvent";
import { FocusSDK as focusSDK } from "@/utils";
import { DragState, DragType, DragViewType } from "../../Enums";
import { Schedule } from "@/api/calendar";
import { useRefreshCurrentTime } from "../../myHooks";
import { throttle } from "lodash";

export interface SchedulePositionInfoProps {
  scheduleId: string;
  userName: string;
  scheduleStart: Dayjs;
  scheduleEnd: Dayjs;
}
// 下拉的时间间隔改成15分钟
export const timeInterval = 15;
// 2020-05-01 12:22 得到-》2020-05-01 12:30
export function getTimeWithFixedMinute (t: dayjs.Dayjs) {
  let minute = t.minute();
  let fixedMin = parseInt((minute / timeInterval).toString(), 10) * timeInterval + timeInterval;
  return t.minute(fixedMin);
}

// 通过时间计算位置
// eslint-disable-next-line max-params
export function calculateTimeByPosition(
  beginTime: Dayjs,
  endTime: Dayjs,
  selTime: Dayjs,
  schedulePositionList: SchedulePositionInfoProps[],
  dom: any
) {
  // 开始时间早于selTime，则selTime 0点开始
  const selBeginTime = dayjs(selTime.format("YYYY-MM-DD") + " 00:00");
  let btime = beginTime;
  if (beginTime.isBefore(selBeginTime)) {
    btime = selBeginTime;
  }
  // 结束时间晚于selTime，则selTime 24点结束
  const selEndTime = dayjs(selTime.format("YYYY-MM-DD") + " 23:59");
  let etime = endTime;
  if (endTime.isAfter(selEndTime)) {
    etime = selEndTime;
  }
  // console.log("time--->>>", beginTime, btime, endTime, etime);
  const star = selTime.startOf("day");
  const top = Math.round(((btime.unix() - star.unix()) * 24 * 48) / (60 * (60 * 24)));
  const bottom = Math.round(((etime.unix() - star.unix()) * 24 * 48) / (60 * (60 * 24)));
  const pIdx = schedulePositionList?.findIndex(
    (item: SchedulePositionInfoProps) =>
      (btime.isAfter(item.scheduleStart, "minute") && btime.isBefore(item.scheduleEnd, "minute")) ||
      (etime.isAfter(item.scheduleStart, "minute") && etime.isBefore(item.scheduleEnd, "minute")) ||
      (btime.isSameOrBefore(item.scheduleStart, "minute") &&
        etime.isSameOrAfter(item.scheduleEnd, "minute"))
  );
  if (dom) {
    dom.style.top = top + "px";
    dom.style.bottom = "";
    dom.style.height = bottom - top + "px";
    dom.style.borderTop = pIdx > -1 ? "1px dotted #ED6A0C" : "1px dotted #1686FF";
    dom.style.borderBottom = pIdx > -1 ? "1px dotted #ED6A0C" : "1px dotted #1686FF";
    dom.style.background = pIdx > -1 ? "rgba(237,106,12,0.6)" : "rgba(22,134,255,0.6)";
    dom.innerText = `${btime.format("HH:mm")}-${etime.format("HH:mm")}`;
  }
}

export function BusyIdleView ({
  selTime,
  beginTime,
  endTime,
  schedulesByUserList,
  modifyScheduleId,
  scrollRef,
  busyIdleDivEl,
  busyIdleTimeBlock,
  schedulePositionInfo,
  scheduleViewDrawRef,
  updateTimeState
}: {
  selTime: Dayjs;
  beginTime: Dayjs | null;
  endTime: Dayjs | null;
  schedulesByUserList: ScheduleByDateAndUsersProps[];
  modifyScheduleId?: string;
  scrollRef: any;
  busyIdleDivEl: any;
  busyIdleTimeBlock: any;
  schedulePositionInfo: any;
  scheduleViewDrawRef: any;
  updateTimeState: Function;
}) {
  const busyIdleScrollRef: any = useRef(null);
  const busyIdleDataRef = useRef({
    scrollUpTimer: null as any,
    scrollDownTimer: null as any,
    curDayIdx: -1,
    curDayStartTime: dayjs(),
    originCilentHeight: 0,
    originScrollHeight: 0,
    container: null as any,
    containerHeight: 0,
    minHeight: 0,
    minUnitHeight: 0,
    isMouseDown: false,
    mouseY: 0,
    dragDivHeight: 0,
    scrollTop: 0,
    originScrollTop: 0,
    dragStartTop: 0,
    isUnderOrigin: true,
    commonOffsetTop: 0,
    curDragType: DragType.DRAGCREATE,
    curMoveSchedule: null as Schedule | null,
    dragDom: null as any,
    dragBorder: "",
    dragStartY: 0,
    dragBorderStartTop: 0,
    dragBorderStartBottom: 0
  });
  const currentTimeObj = useRefreshCurrentTime();

  const getViewScheduleByUserContent = (list: ScheduleByUser[], calendarScope: number) => {
    const content = getScheduleByUserElements({
      selTime: selTime,
      list: modifyScheduleId
        ? list?.filter((item) => item.scheduleId !== modifyScheduleId) || []
        : list || []
    });
    let positionInfo: SchedulePositionInfoProps[] = [];
    const eTime = dayjs(selTime.format("YYYY-MM-DD") + " 23:59");
    const sTime = dayjs(selTime.format("YYYY-MM-DD") + " 00:00");
    const viewcontent = content.map(({ schedule, styles }, index) => {
      const { scheduleId, userName } = schedule;
      let scheduleStart = dayjs(schedule.beginTime).isBefore(sTime)
        ? sTime
        : dayjs(schedule.beginTime);
      let scheduleEnd = dayjs(schedule.endTime).isAfter(eTime) ? eTime : dayjs(schedule.endTime);
      positionInfo = [
        ...positionInfo,
        {
          scheduleId,
          userName,
          scheduleStart,
          scheduleEnd
        }
      ];
      return (
        <ViewScheduleByUserItem
          key={"participant-" + schedule.scheduleId + schedule.userId + index}
          selTime={selTime}
          schedule={schedule}
          styles={styles}
          calendarScope={calendarScope}
        />
      );
    });
    schedulePositionInfo.current = [...schedulePositionInfo.current, ...positionInfo];
    return viewcontent;
  };

  const getViewScheduleByUserContentHandle = useMemo(() => {
    if (!schedulesByUserList.length) return null;
    schedulePositionInfo.current = [];
    const view = schedulesByUserList.map((item: ScheduleByDateAndUsersProps, index: number) => {
      return (
        <div key={"schedules-user-" + index} className="schedule-view-item">
          {getViewScheduleByUserContent(item.schedules, item.calendarScope)}
        </div>
      );
    });
    return view;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [schedulesByUserList]);

  const isDragBorder = (e: any, curDom: any, judgeBorder: boolean) => {
    const event = e || window.event; // 解决浏览器兼容问题
    const rect = curDom.getBoundingClientRect();
    if (event.clientY > rect?.top && event.clientY < rect?.top + 3) {
      if (judgeBorder) {
        busyIdleDataRef.current.dragBorder = "top";
      }
      return true;
    } else if (event.clientY < rect?.bottom && event.clientY > rect?.bottom - 3) {
      if (judgeBorder) {
        busyIdleDataRef.current.dragBorder = "bottom";
      }
      return true;
    } else {
      return false;
    }
  };

  // 通过位置计算时间
  const calculatePositionByTime = (cu: any, clientY: number) => {
    const top = cu.parentNode?.parentNode?.parentNode?.scrollTop;
    const offset = cu.offsetTop;
    const scrollHeight = cu.scrollHeight;
    const viewOffset: any = (scheduleViewDrawRef.current as any)?.parentNode.offsetTop;
    const position = clientY - viewOffset - offset + top;
    const count = Math.round(Math.floor((position / scrollHeight) * 60 * 24) / 15) * 15;
    return selTime.startOf("date").add(count, "minute");
  };

  // 计算冲突
  const calculateConflicts = (el: any, beginTime: Dayjs, endTime: Dayjs) => {
    const pIdx = schedulePositionInfo.current?.findIndex(
      (item: SchedulePositionInfoProps) =>
        (beginTime.isAfter(item.scheduleStart, "minute") &&
          beginTime.isBefore(item.scheduleEnd, "minute")) ||
        (endTime.isAfter(item.scheduleStart, "minute") &&
          endTime.isBefore(item.scheduleEnd, "minute")) ||
        (beginTime.isSameOrBefore(item.scheduleStart, "minute") &&
          endTime.isSameOrAfter(item.scheduleEnd, "minute"))
    );
    el.style.borderTop = pIdx > -1 ? "1px dotted #ED6A0C" : "1px dotted #1686FF";
    el.style.borderBottom = pIdx > -1 ? "1px dotted #ED6A0C" : "1px dotted #1686FF";
    el.style.background = pIdx > -1 ? "rgba(237,106,12,0.6)" : "rgba(22,134,255,0.6)";
  };

  // 拖动过程中更新时间
  const updateDragBusyIdleTime = throttle(
    // eslint-disable-next-line max-params
    (ev: any, dragState: string, dragType: number, el: any) => {
      const cu: any = busyIdleDivEl.current;
      if (el && cu) {
        const boxRect = el.getBoundingClientRect();
        const { top: boxRectTop, bottom: boxRectBottom } = boxRect;
        let beginTime = calculatePositionByTime(cu, boxRectTop);
        let endTime = calculatePositionByTime(cu, boxRectBottom);
        // 如果结束时间是第二天的00:00 则建减一分钟 拖动不创建跨天日程
        if (endTime.valueOf() === dayjs(selTime.format("YYYY-MM-DD")).add(1, "day").valueOf()) {
          endTime = endTime.subtract(1, "minute");
        }
        if (dragType === DragType.DRAGTIMEBLOCKEDIT || dragType === DragType.DRAGBORDEREDIT) {
          el.innerText = `${beginTime.format("HH:mm")}-${endTime.format("HH:mm")}`;
          if (dragState === DragState.UP) {
            // up的时候进行时间和色块的最终设定（归位）
            // 回调更新时间
            updateTimeState(beginTime, endTime);
          }
        }
        calculateConflicts(el, beginTime, endTime);
      }
    },
    50
  );

  const handleBusyIdleMouseDown = (e: any, dragType: number) => {
    try {
      const event = e || window.event; // 解决浏览器兼容问题
      if (event.button !== 0) return;
      pauseEvent(event);
      let container: any = busyIdleDivEl.current;
      if (!container) return;
      handleMouseDownFun({
        event,
        dataRef: busyIdleDataRef,
        scrollRef: busyIdleScrollRef,
        container,
        dragType,
        dragDom: busyIdleTimeBlock.current
      });
    } catch (error) {
      focusSDK.printLog("handleBusyIdleMouseDown-->>", error.message?.toString());
    }
    window.addEventListener("mousemove", handleBusyIdleMouseMove);
    window.addEventListener("mouseup", handleBusyIdleMouseUp);
  };

  const handleBusyIdleMouseMove = useCallback(
    (e: any) => {
      try {
        const event = e || window.event; // 解决浏览器兼容问题
        pauseEvent(event);
        handleMouseMoveFun({
          event,
          dataRef: busyIdleDataRef,
          scrollRef: busyIdleScrollRef,
          dragView: DragViewType.BUSYIDLE,
          updateDragTime: updateDragBusyIdleTime
        });
      } catch (error) {
        focusSDK.printLog("handleBusyIdleMouseMove-->>", error.message?.toString());
      }
    },
    [updateDragBusyIdleTime]
  );

  const handleBusyIdleMouseUp = useCallback(
    (e: any) => {
      try {
        const event = e || window.event; // 解决浏览器兼容问题
        pauseEvent(event);
        handleBusyIdleMouseUpFun({
          event,
          dataRef: busyIdleDataRef,
          dragView: DragViewType.BUSYIDLE,
          updateDragTime: updateDragBusyIdleTime
        });
      } catch (error) {
        focusSDK.printLog("handleBusyIdleMouseUp-->>", error.message?.toString());
      }
      window.removeEventListener("mousemove", handleBusyIdleMouseMove);
      window.removeEventListener("mouseup", handleBusyIdleMouseUp);
    },
    [handleBusyIdleMouseMove, updateDragBusyIdleTime]
  );

  const handleScrollFrame = (e: any) => {
    try {
      const event = e || window.event; // 解决浏览器兼容问题
      pauseEvent(event);
      handleScrollFrameFun({
        event,
        dataRef: busyIdleDataRef,
        scrollRef,
        updateDragTime: updateDragBusyIdleTime
      });
    } catch (error) {
      focusSDK.printLog("handleScrollFrame-->>", error.message?.toString());
    }
  };

  const handleMouseMove = (e: any, curDom: any) => {
    if (!curDom) return;
    if (isDragBorder(e, curDom, false)) {
      curDom.style.cursor = "row-resize";
    } else {
      curDom.style.cursor = "pointer";
    }
  };

  const handleMouseOut = (e: any, curDom: any) => {
    if (!curDom) return;
    curDom.style.cursor = "default";
  };

  const handleMouseDown = (e: any, curDom: any) => {
    if (!curDom) return;
    if (isDragBorder(e, curDom, true)) {
      handleBusyIdleMouseDown(e, DragType.DRAGBORDEREDIT);
    } else {
      handleBusyIdleMouseDown(e, DragType.DRAGTIMEBLOCKEDIT);
    }
  };

  useEffect(() => {
    setTimeout(() => {
      if (busyIdleScrollRef?.current) {
        const sHeigh = busyIdleScrollRef.current?.getScrollHeight();
        const sTop = busyIdleScrollRef.current?.getScrollTop();
        const cHeight = busyIdleScrollRef.current?.getClientHeight();
        if (currentTimeObj.top > sHeigh - cHeight) {
          busyIdleScrollRef.current?.scrollToBottom();
          busyIdleDataRef.current.scrollTop = sHeigh - cHeight;
        } else if (currentTimeObj.top < cHeight / 2) {
          busyIdleScrollRef.current?.scrollToTop();
          busyIdleDataRef.current.scrollTop = 0;
        } else {
          busyIdleScrollRef.current?.scrollTop(currentTimeObj.top - cHeight / 4);
          busyIdleDataRef.current.scrollTop = currentTimeObj.top - cHeight / 4;
        }
      }
    }, 0);
    return () => {
      window.removeEventListener("mousemove", handleBusyIdleMouseMove);
      window.removeEventListener("mouseup", handleBusyIdleMouseUp);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="calendar-busyidle-container">
      <ScrollView
        onScrollFrame={handleScrollFrame}
        ref={busyIdleScrollRef}
        className="scroll-view"
        autoHide
        renderTrackVertical={() => (
          <div
            style={{
              position: "absolute",
              width: "8px",
              transition: "opacity 200ms ease 0s",
              opacity: "0",
              right: "2px",
              bottom: "2px",
              top: "2px",
              borderRadius: "3px",
              zIndex: 9999
            }}
          />
        )}
        renderTrackHorizontal={() => (
          <div
            style={{
              position: "absolute",
              height: "8px",
              transition: "opacity 200ms ease 0s",
              opacity: "0",
              right: "2px",
              bottom: "2px",
              left: "2px",
              borderRadius: "3px",
              zIndex: 9999
            }}
          />
        )}
      >
        <div className="calendar-busyidle-container-content">
          <div className="schedule-view">
            <UserScheduleViewHeader list={schedulesByUserList} />
            <div className="schedule-view-table" ref={busyIdleDivEl}>
              <TimeLableComponent current={dayjs()} currentTimeObj={currentTimeObj} />
              <TimeLineComponent />
              {getViewScheduleByUserContentHandle}
              {selTime.isSame(dayjs(), "day") && (
                <CurrentLine current={selTime} showCircle={false} top={currentTimeObj.top} />
              )}
              <div
                className="time-block"
                id="drag-block-box"
                ref={busyIdleTimeBlock}
                onMouseMove={(e) => handleMouseMove?.(e, busyIdleTimeBlock.current)}
                onMouseOut={(e) => handleMouseOut?.(e, busyIdleTimeBlock.current)}
                onMouseDown={(e) => handleMouseDown?.(e, busyIdleTimeBlock.current)}
              >
                {beginTime?.format("HH:mm") +
                  "-" +
                  (endTime?.isSame(selTime, "day") ? endTime?.format("HH:mm") : "23:59")}
              </div>
            </div>
          </div>
        </div>
      </ScrollView>
    </div>
  );
}
